const state = {
  itens: null,
  item: {
    name: "",
    is_active: false
  }
};

export default state;
